import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootReducer } from '@store/index';
import { BranchOffice } from '@api/BranchOffices/BranchOffice';
import { buildPermissionSubject, PermissionSubject, visibleBranchOffices } from '@utils/Permissions/Capabilities';

/**
 * El sujeto de permisos REACTIVO: cambia con "Ver como" y con la sucursal del sidebar.
 * `getCurrentPermissionSubject()` lee el store una vez y sirve en servicios y
 * handlers; en el render de una pantalla va este hook, para que un `useMemo` que
 * filtre por el sujeto (la lista de Usuarios) se recalcule al cambiar de sucursal
 * mientras se previsualiza.
 */
export const usePermissionSubject = (): PermissionSubject => {
    const { loggedUser, profileSelected, branchOfficeSelected } = useSelector((state: RootReducer) => state.auth);
    return useMemo(
        () => buildPermissionSubject({ loggedUser, profileSelected, branchOfficeSelected }),
        [loggedUser, profileSelected, branchOfficeSelected]
    );
};

/**
 * Las sucursales del catálogo que ve quien opera: lo que llena un selector de
 * sucursal. Para el admin real son todas; para un gerente o admin de sucursal, las
 * suyas; en "Ver como", la del sidebar. (El catálogo del store ya llega acotado al
 * usuario REAL — `refreshBranchOffices` —; esto acota además la previsualización.)
 */
export const useVisibleBranchOffices = (): BranchOffice[] => {
    const subject = usePermissionSubject();
    const { branchOffices } = useSelector((state: RootReducer) => state.krispis);
    return useMemo(() => visibleBranchOffices(subject, branchOffices), [subject, branchOffices]);
};
